// src/constants/cities.ts

import { City } from "@components/organisms/CitySelectionModal/City.types";

export const FALLBACK_CITIES: any = [
  { id: 3, name: "Delhi", inbound_number: "18002662250", icon: "Delhi" },
  {
    id: 1,
    name: "Bangalore",
    inbound_number: "18002662250",
    icon: "Bangalore",
  },
  { id: 2, name: "Mumbai", inbound_number: "18002662250", icon: "Mumbai" },
  { id: 4, name: "Noida", inbound_number: "18002662250", icon: "Noida" },
  { id: 5, name: "Gurgaon", inbound_number: "18002662250", icon: "Gurgaon" },
  { id: 6, name: "Pune", inbound_number: "18002662250", icon: "Pune" },
  {
    id: 8,
    name: "Faridabad",
    inbound_number: "18002662250",
    icon: "Faridabad",
  },
  {
    id: 7,
    name: "Ghaziabad",
    inbound_number: "18002662250",
    icon: "Ghaziabad",
  },
  {
    id: 9,
    name: "Hyderabad",
    inbound_number: "18002662250",
    icon: "Hyderabad",
  },
  { id: 10, name: "Chennai", inbound_number: "18002662250", icon: "Chennai" },
  {
    id: 11,
    name: "Ahmedabad",
    inbound_number: "18002662250",
    icon: "Ahmedabad",
  },
  { id: 12, name: "Jaipur", inbound_number: "18002662250", icon: "Jaipur" },
  {
    id: 13,
    name: "Chandigarh",
    inbound_number: "18002662250",
    icon: "Chandigarh",
  },
];

export const CITY_ALIASES: Record<string, string> = {
  bengaluru: "bangalore",
};

export const defaultCity: City = { id: 3, name: "Delhi", inbound_number: "18002662250", icon: "Delhi", city_slug: "delhi" };
